import { TableCell, TableRow, Typography } from "@mui/material";
import { sumBy } from "lodash";
import type { FC } from "react";
import type { ProviderProductRow } from "../statisticsApi";
import { formatEur } from "../statisticsFormat";
import ReportTable from "./ReportTable";

const COLUMNS = [
  { label: "Produkt" },
  { label: "Ilość zamówień", align: "right" as const },
  { label: "Wartość EUR", align: "right" as const },
];

interface Props {
  readonly rows: ProviderProductRow[];
}

const ProviderProductsTable: FC<Props> = ({ rows }) => {
  if (rows.length === 0) {
    return <Typography sx={{ color: "text.secondary" }}>Brak produktów dostawcy w wybranym okresie</Typography>;
  }
  return (
    <ReportTable columns={COLUMNS}>
      {rows.map((row) => (
        <TableRow key={row.productId} hover>
          <TableCell>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {row.productName}
            </Typography>
          </TableCell>
          <TableCell align="right">{row.ordersCount}</TableCell>
          <TableCell align="right">{formatEur(row.valueEur)}</TableCell>
        </TableRow>
      ))}
      <TableRow sx={{ bgcolor: "rgba(0,0,0,0.02)" }}>
        <TableCell sx={{ fontWeight: "bold" }}>Razem</TableCell>
        <TableCell align="right" sx={{ fontWeight: "bold" }}>
          {sumBy(rows, (row) => row.ordersCount)}
        </TableCell>
        <TableCell align="right" sx={{ fontWeight: "bold" }}>
          {formatEur(sumBy(rows, (row) => row.valueEur))}
        </TableCell>
      </TableRow>
    </ReportTable>
  );
};

export default ProviderProductsTable;
